import getTypeOfAttachment from './getTypeOfAttachment';
import AttachmentModel, { ReferenceAttachmentModel } from '../store/schema/AttachmentModel';
import TypeOfAttachment from '../store/schema/TypeOfAttachment';
import AttachmentType from 'owa-service/lib/contract/AttachmentType';
import ReferenceAttachment from 'owa-service/lib/contract/ReferenceAttachment';

export default function isCloudyAttachment(
    attachment: AttachmentModel
): attachment is ReferenceAttachmentModel {
    return isCloudyTypeAttachment(attachment.type);
}

export function isCloudyAttachmentType(
    attachment: AttachmentType
): attachment is ReferenceAttachment {
    const typeOfAttachment = getTypeOfAttachment(attachment);
    return isCloudyTypeAttachment(typeOfAttachment);
}

function isCloudyTypeAttachment(attachmentType: TypeOfAttachment): boolean {
    return attachmentType === TypeOfAttachment.Reference;
}
